
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruitment-solutions/case-studies",
      function () {
        return require("private-next-pages/recruitment-solutions/case-studies/index.page.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruitment-solutions/case-studies"])
      });
    }
  